import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { ProgramIncrementIcon } from './ProgramIncrementIcon';
import { ProgramIncrementName } from './ProgramIncrementName';

export class ProgramIncrementFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [ProgramIncrementIcon, ProgramIncrementName];
  }

  get title() {
    return terminology('Program increment');
  }
}
